/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useShallow } from 'zustand/react/shallow';

import { getBotDetailIsReadonlyByState } from '../utils/get-read-only';
import { usePageRuntimeStore } from '../store/page-runtime';
import { useCollaborationStore } from '../store/collaboration';

export const useBotDetailIsReadonly = (): boolean => {
  const { editable, isPreview } = usePageRuntimeStore(
    useShallow(state => ({
      editable: state.editable,
      isPreview: state.isPreview,
    })),
  );
  const editLockStatus = useCollaborationStore(state => state.editLockStatus);
  return getBotDetailIsReadonlyByState({
    editable,
    isPreview,
    editLockStatus,
  });
};
